import React from 'react';
import { SearchFieldV2 as SearchField, FormFieldV2 as FormField } from '@/components/custom/erp';
import { khachHangSearchColumns, QUERY_KEYS } from '@/constants';
import { accountSearchColumns } from './search-cols-definition';
import { AccountModel, KhachHang } from '@/types/schemas';
import { Label } from '@/components/ui/label';

interface BasicInfoProps {
  khachHang: KhachHang | null;
  taiKhoan: AccountModel | null;
  setTaiKhoan: (taiKhoan: AccountModel) => void;
  setKhachHang: (khachHang: KhachHang) => void;
}

const BasicInfo: React.FC<BasicInfoProps> = ({ khachHang, taiKhoan, setKhachHang, setTaiKhoan }) => {
  return (
    <div className='max-h-[calc(100vh-150px)] w-[800px] min-w-[800px] overflow-y-auto'>
      <div className='space-y-2 p-4'>
        <div className='flex flex-col space-y-1'>
          <div className='flex items-center'>
            <Label className='w-40 min-w-40'>Năm</Label>
            <div>
              <FormField name='year' type='number' className='w-32' />
            </div>
          </div>
          <div className='flex items-center'>
            <Label className='w-40 min-w-40'>Mã khách hàng:</Label>
            <SearchField<KhachHang>
              type='text'
              className='w-64'
              searchEndpoint={`/${QUERY_KEYS.KHACH_HANG}/`}
              value={khachHang?.customer_code || ''}
              searchColumns={khachHangSearchColumns}
              onRowSelection={setKhachHang}
            />
          </div>
          <div className='flex items-center'>
            <Label className='w-40 min-w-40'>Tài khoản:</Label>
            <SearchField<AccountModel>
              type='text'
              className='w-64'
              searchEndpoint={`/${QUERY_KEYS.TAI_KHOAN}/`}
              value={taiKhoan?.code || ''}
              onRowSelection={setTaiKhoan}
              dialogTitle='Danh mục tài khoản'
              searchColumns={accountSearchColumns}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default BasicInfo;
